import React, { useState, useContext } from "react";
import authFetch from "../authFetch";
import PlatformCtx from "../state/PlatformCtx";
import mdToHtml from "../utils/mdToHtml";
import T from "../i18n/translations";

function AIPanel({title,context,prompt,lang,moduleKey,wsState}){
  const isRTL=lang==="ar";
  const t=T[isRTL?"ar":"en"];
  const platformCtx=useContext(PlatformCtx);
  const [resp,setResp]=useState("");const [loading,setLoading]=useState(false);const [ran,setRan]=useState(false);
  const [activePrompt,setActivePrompt]=useState("");
  const [customQ,setCustomQ]=useState("");
  const cfg=(platformCtx?.aiAgents||{})[moduleKey]||{};
  /* Sub-agents inherit parent module's disabled state */
  const parentKey=moduleKey==="RecurringIncome"?"Income":moduleKey==="RecurringExpenses"?"Expenses":moduleKey;
  const wsAiOff=(wsState?.wsAiDisabled||{})[moduleKey]||(wsState?.wsAiDisabled||{})[parentKey];
  const wsAllOff=wsState?.wsAiAllDisabled;
  const agentTitle=cfg.title||title;
  const agentModel=cfg.model||"claude-sonnet-4-20250514";
  const agentMaxTokens=cfg.maxTokens||800;
  const agentSystem=cfg.systemPrompt||"You are a private office AI. Concise, max 200 words, dash bullet points, no headers.";
  const agentDefaultPrompt=cfg.defaultPrompt||prompt;
  const suggested=cfg.suggestedPrompts||[];
  /* If platform-level disabled OR workspace-level disabled, hide entirely */
  if(cfg.enabled===false||wsAiOff||wsAllOff)return null;
  const run=async(customPrompt)=>{
    const q=customPrompt||activePrompt||agentDefaultPrompt;
    setLoading(true);setRan(true);setResp("");setActivePrompt(q);
    try{
      const r=await authFetch("/api/ai-chat",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({model:agentModel,max_tokens:agentMaxTokens,system:`${agentSystem} Respond in ${lang==="ar"?"Arabic":"English"}.`,messages:[{role:"user",content:`Context:\n${context}\n\nQuery: ${q}`}]})});
      const d=await r.json();
      if(d.error)setResp("Error: "+d.error);
      else setResp(d.content?.[0]?.text||t.noResponseReceived);}
    catch(e){setResp(t.aiUnavailable+e.message);}
    setLoading(false);
  };
  return(
    <div className="aip">
      <div className="aih"><div className="ai-dot"/><div className="ai-lbl">{agentTitle}</div><button className="btn btn-gold btn-sm" onClick={()=>{if(customQ.trim()){run(customQ.trim());setCustomQ("");}else run();}} disabled={loading}>{loading?"...":ran?t.refresh:t.askAI}</button></div>
      <div className="aib">
        {/* Free-text input */}
        <div style={{display:"flex",gap:8,marginBottom:10}}>
          <input value={customQ} onChange={e=>setCustomQ(e.target.value)} placeholder={t.askAnythingPlaceholder} onKeyDown={e=>{if(e.key==="Enter"&&customQ.trim()){run(customQ.trim());setCustomQ("");}}} style={{flex:1,border:"1px solid var(--gold-bd)",borderRadius:20,padding:"7px 14px",fontSize:13,outline:"none",background:"var(--white)",color:"var(--ink)"}}/>
        </div>
        {!ran&&<>
          {suggested.length>0&&<div style={{display:"flex",flexWrap:"wrap",gap:6}}>
            {suggested.map((sp,i)=><button key={i} className="btn btn-s btn-sm" style={{fontSize:11,fontWeight:500,borderRadius:20,padding:"5px 12px",textAlign:"left",lineHeight:1.3}} onClick={()=>run(sp)}>{sp}</button>)}
          </div>}
        </>}
        {loading&&<div className="ai-ld"><div className="ai-db"/><div className="ai-db"/><div className="ai-db"/></div>}
        {!loading&&resp&&<>
          <div className="ai-r" dangerouslySetInnerHTML={{__html:mdToHtml(resp)}}/>
          {suggested.length>0&&<div style={{display:"flex",flexWrap:"wrap",gap:6,marginTop:12,paddingTop:12,borderTop:"1px solid var(--gold-bd)"}}>
            <span style={{fontSize:10,fontWeight:600,color:"var(--amb)",textTransform:"uppercase",letterSpacing:".06em",alignSelf:"center",marginInlineEnd:4}}>{t.tryColon}</span>
            {suggested.filter(sp=>sp!==activePrompt).slice(0,3).map((sp,i)=><button key={i} className="btn btn-s btn-sm" style={{fontSize:11,fontWeight:500,borderRadius:20,padding:"5px 12px",textAlign:"left",lineHeight:1.3}} onClick={()=>run(sp)}>{sp}</button>)}
          </div>}
        </>}
      </div>
    </div>
  );
}

export default AIPanel;
